/**
 * @ngdoc enum
 * @name SystemStorageType
 * @module mx.app
 *
 * @description
 * Browser data storage types
 */
export const enum SystemStorageType {
	/**
	 * @ngdoc property
	 * @name SystemStorageType#Cookies
	 *
	 * @description
	 * Browser Cookies
	 */
	Cookies = 'cookies',

	/**
	 * @ngdoc property
	 * @name SystemStorageType#LocalStorage
	 *
	 * @description
	 * Browser's LocalStorage database
	 */
	LocalStorage = 'local',
}
